import hasBarShifts from "./hasBarShifts";
import hasPlural from "./hasPlural";

/**
 * "Naručeno" (računar i telefon): porudžbenice radnika razvrstane po smenama. Zahteva nasleđen stari tab
 * ReportMealsTabOrders (getUsersForShift, sortedSelectedShifts, selectedShifts, filters, loading).
 * Smene iz trake/zaglavlja dolaze preko hasBarShifts.
 */
export default {
  mixins: [hasPlural, hasBarShifts],
  computed: {
    isRange() {
      const { from, to } = this.filters.dates;
      return Boolean(to && from !== to);
    },
    /** Smene sa narudžbama: porudžbenice radnika sortirane po imenu. */
    groups() {
      return this.sortedSelectedShifts
        .map((id) => {
          const slips = this.getUsersForShift(id)
            .map((user) => this.toSlip(id, user))
            .sort((a, b) => a.name.localeCompare(b.name));
          const mealCount = slips.reduce(
            (sum, slip) => sum + slip.meals.reduce((total, meal) => total + (Number(meal.total) || 0), 0),
            0
          );
          return { id, slips, mealCount };
        })
        .filter((group) => group.slips.length);
    },
    workerTotal() {
      const ids = new Set();
      this.groups.forEach((group) => group.slips.forEach((slip) => ids.add(slip.id)));
      return ids.size;
    },
    mealTotal() {
      return this.groups.reduce((sum, group) => sum + group.mealCount, 0);
    },
    emptyTitle() {
      return this.filters.search
        ? this.$t("report_mobile.no_results_for", { search: this.filters.search })
        : this.$t("report_mobile.no_meals");
    },
    emptyText() {
      return this.filters.search ? "" : this.$t("report_desktop.empty_hint");
    },
  },
  methods: {
    toSlip(shiftId, user) {
      const name = [this.toLatin(user.name), this.toLatin(user.lastname)].filter(Boolean).join(" ").trim();
      return {
        key: `${shiftId}-${user.id}`,
        id: user.id,
        name,
        initials: [user.name, user.lastname]
          .filter(Boolean)
          .map((part) => String(part).charAt(0))
          .join(""),
        orderId: user.meals.length ? user.meals[0].order_id : "",
        meals: user.meals.map((meal) => ({ name: this.toLatin(meal.name), total: meal.total })),
      };
    },
    groupSummary(group) {
      return [
        this.pluralT("report_mobile.workers_n", group.slips.length),
        this.pluralT("report_mobile.meals_n", group.mealCount),
      ].join(" · ");
    },
  },
};
